<template>
  <div id="apart_main">
    <div class="flex-coloum flex-1"
      style="overflow: auto;margin-bottom: 20px;box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);border-radius: 8px;">
      <div class="apart-top flex-row flex-row-between ">
        <div class="flex-row t-p-l-25">
          <span class="apart-top-title">
            小说转剧本
          </span>
        </div>
        <el-button type="primary" @click="handleAdd" style="border-radius: 10px;margin-right: 25px;">
          <span class="el-icon-plus" style="font-weight: bold;"></span>
          <span>前往转换</span>
        </el-button>
      </div>
      <div v-if="!listStatus" class="empty-list">
        <img class="empty-icon cursor_1" :src="require('@/assets/image/no_data.png')" @click="handleAdd">
        <span @click="handleAdd" class="cursor_1">暂无内容,请点击去拆书</span>
      </div>
      <div v-else class="apart-list">
        <div class="apart-item" v-for="(item, i) in list" :key="i" @click.stop="toPage(item.id,item.title)">
          <div class="apart-title" style="display: flex;justify-content: space-between;">
            <span>{{ item.title }}</span>
            <span style="font-weight: 400;color: #FF7821;font-size: 16px;">已转: {{ item.apartCount }}章</span>
          </div>
          <div class="apart-info">
            <div style="width: 30%;">
              <span>总字数: {{ item.totalWord }}</span>
              &nbsp;
              <!-- <span>已转: {{ item.apartCount }}章</span>
              &nbsp; -->
              <span>{{ item.uploadTime }}</span>
            </div>
            <div class="info-right noBorderArray">

              <template v-for="(items, l) in apartListIcon">
                <el-tooltip :key="l" popper-class="novel_toolTip1" :disabled="Object.hasOwn(items, 'title') ? false : true"
                  placement="top" effect="light" :content="items.title">
                  <div class="cursor_1 btn_item" @click.stop="nextStep(item, l)"
                    @mouseenter="() => { selectedIndex = l; selectedId = item.id }"
                    @mouseleave="() => { selectedIndex = -1; selectedId = '' }">
                    <img class="t-m-r-5" :src="selectedIndex === l && selectedId == item.id ? items.icon : items.uIcon"
                      alt="">
                    <span>{{ items.name }}</span>
                  </div>
                </el-tooltip>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottomPage v-if="total" :total="total" @currentNUm="currentNum" ref="bottompage"></bottomPage>
    <loadingStatus v-if="loading"></loadingStatus>
    <popup ref="delPopup" @confirm="confirm"></popup>
  </div>

</template>
<script>
import data from '@/assets/data';
import api from '@/api/apart';
import bottomPage from '@/components/bottom_page.vue'
import loadingStatus from '@/components/loading_status.vue' //加载效果
import popup from '@/components/dongeb/popup.vue';
export default {
  components: {
    bottomPage,
    loadingStatus,
    popup,
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      listStatus: true,
      selectId: 0,
      apartListIcon: data.novelTurnListIcon,//作品编辑
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        type: 1
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleAdd() {
      this.$router.push('/novelTurnScript_add')
    },
    confirm() {
      //执行删除操作
      try {
        api.del({ id: this.selectId,type:1 }).then(res => {
          if (res.code === 200) {
            this.getList();
          }
        })
      } catch (error) {
        this.loading = false
      }

    },
    del(id) {
      this.selectId = id
      this.$refs.delPopup.openPrompt(9);
    },
    getList() {
      this.loading = true
      let queryParams = JSON.parse(sessionStorage.getItem('turnPage'))
      this.queryParams = queryParams && Object.keys(queryParams).length > 0 ? queryParams : this.queryParams
      api.getApartList(this.queryParams).then((res) => {
        if (res.code === 200) {
          this.total = res.total
          this.list = res.rows
          this.listStatus = this.list.length > 0 ? true : false
          this.$nextTick(() => {
            if (this.total && this.$refs.bottompage) {
              this.$refs.bottompage.page(queryParams && Object.keys(queryParams).length > 0 ? queryParams.pageNum : this.queryParams.pageNum)
            }
          })

        }

      }).catch(() => {
        this.listStatus = false
      }).finally(() => {
        this.loading = false
      })
    },
    nextStep(item, index) {
      if (index === 0) {
        this.toPage(item.id,item.title)
        return
      }
      if (index === 1) {
        this.del(item.id)
        return
      }
    },
    toPage(id,title) {
      sessionStorage.setItem('turnPage', JSON.stringify(this.queryParams))
      this.$router.push({ path: '/novelTurnScript_chapter', query: { id,title } })
    },
    currentNum(pageNum) {
      this.queryParams.pageNum = pageNum
      sessionStorage.setItem('turnPage', JSON.stringify(this.queryParams))
      this.getList()
    },
  }
}
</script>
<style lang="scss" scoped>
.list-btn {
  color: #333333;
}

.btn-icon {
  width: 17px;
  height: 17px;
}

.btn-icon,
.btn-text {
  vertical-align: middle;
  font-family: PingFang SC, PingFang SC;
}

.btn-text {
  margin-left: 2px;
}

.info-right {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  width: 200px;
}

.apart-title {
  padding-top: 33px;
  padding-bottom: 19px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 17px;
  color: #111111;
  line-height: 17px;
}

.apart-info {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 17px;
  // color: #FF8E0D;
  color: var(--tech-primary);
  line-height: 17px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.apart-item {
  margin: 0 25px;
  height: 106px;
  position: relative;

  // &:last-child{
  //   &::before{
  //     height: 0 !important;
  //   }
  // }
  &::before {
    content: " ";
    position: absolute;
    bottom: 0;
    height: 1px;
    width: 100%;
    background-color: #E6EBF0;
  }
}

.empty-list {
  width: 100%;
  height: 92%;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  /* 子元素垂直排列 */
  justify-content: center;
  /* 整体垂直居中 */
  align-items: center;
}

.add-btn:hover {
  color: var(--tech-primary);
  cursor: pointer;
}

.list-btn:hover {
  color: var(--tech-primary);
}

.add-text {
  line-height: 1;
  vertical-align: middle;
}

.add-icon {
  display: inline-block;
  vertical-align: middle;
}

.add-btn {
  height: 100%;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.apart-list {
  width: 100%;
  flex: 1;
  background-color: #FFFFFF;
  overflow: auto;
  @include no_scrollbar();

}

.apart-top {
  width: 100%;
  height: 77px;
  background-color: #FFFFFF;
  position: relative;
  flex-shrink: 0;

  &::before {
    content: " ";
    position: absolute;
    bottom: 0;
    height: 1px;
    width: 100%;
    background-color: #E6EBF0;
  }

  .back-img {
    display: block;
    margin-top: 2px;
  }

  .apart-top-title {
    height: 19px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 19px;
    color: #111111;
    line-height: 19px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-left: 4px;
  }
}

#apart_main {
  flex: 1;
  margin: 16px 0 0 20px;
  border-radius: 8px 8px 0 0;
  position: relative;
  display: flex;
  flex-direction: column;
}
</style>